// ────────────────────────────────────────────────────────────────────
// XZYNEXA logo — text wordmark (no image asset).
//
// Matches the sign-in letterhead: a bold sans wordmark with a single
// accent-coloured "E" (XZYN·E·XA). Adapted for the dark app header
// (light letters instead of the login card's dark ink).
// ────────────────────────────────────────────────────────────────────

// Same accent the sign-in card uses for the "E". One variable, not a literal:
// this renders on the header of every screen, so a stale value here is the
// most-seen colour in the app.
const ACCENT = "var(--accent)";

interface Props {
  size?: "sm" | "md" | "lg";
}

export function Logo({ size = "md" }: Props): JSX.Element {
  const name = { sm: "text-xl", md: "text-2xl", lg: "text-4xl" }[size];

  // No colour class on the wordmark: it inherits its surface. It used to say
  // text-ink-1, which is not a class at all — `ink` is a scalar in the
  // Tailwind config, so only ink-1..4 exist and ink-100 compiled to nothing.
  // It looked right because inheritance was quietly doing the work; on the
  // dark header it now has to be inheritance on purpose.
  return (
    <span
      className={`${name} font-sans font-extrabold inline-block`}
      style={{ letterSpacing: "-0.02em", lineHeight: 1 }}
    >
      XZYN<span style={{ color: ACCENT }}>E</span>XA
    </span>
  );
}
